import type { ReactElement } from 'react';
import { cn } from '@/shared/ui';
import { STORE_EXHIBITION_BANNER_FRAME } from './store-exhibition-banner-frame';

interface StoreExhibitionBannerProps {
  readonly title: string;
  /** 해제 — exhibition 조건만 푼다. 다른 필터·정렬은 그대로 둔다. */
  readonly onClear: () => void;
}

/** 목록 위 기획전 띠 — 지금 보고 있는 목록이 어떤 기획전인지 알리고 해제 수단을 남긴다. */
export const StoreExhibitionBanner = ({
  title,
  onClear,
}: StoreExhibitionBannerProps): ReactElement => (
  <div
    className={cn(
      STORE_EXHIBITION_BANNER_FRAME,
      'flex items-center justify-between gap-4 bg-muted/40',
    )}
  >
    <p className="text-sm font-medium">기획전: {title}</p>
    <button
      type="button"
      aria-label="기획전 필터 해제"
      title="기획전 필터 해제"
      onClick={onClear}
      className="text-muted-foreground transition-colors hover:text-foreground"
    >
      <svg
        aria-hidden="true"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        className="size-4"
      >
        <path d="M18 6 6 18" />
        <path d="m6 6 12 12" />
      </svg>
    </button>
  </div>
);
